import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import AttachmentUploader from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { getAttachmentInfo } from '@src/slide/domain/ui-model/element-modeles/property/attachment/utils/attachment';

@Feature()
export class ViewAttachmentFeature extends BaseMobileContextMenuFeature {
    public id = config.name;

    public viewAttachment(): void {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        const attachmentInfo = getAttachmentInfo(model);
        if (!attachmentInfo) {
            return;
        }
        AttachmentUploader.getInstance().viewAttachmentInfo(attachmentInfo);
    }
}
